import { Add } from '@mui/icons-material'
import { Box, Icon, InputAdornment, Typography, ListSubheader } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInput from 'components/custom/AdxInput'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import { ErrorMessage, Field, FieldArray } from 'formik'
import React, { useEffect, useState } from 'react'

const CustomAdditional = ({ addCustomItem, formikProps, setStateChanges }) => {
  const [additionalItemOption, setAdditionalItemOption] = useState([])
  const [addItem, setAddItem] = useState(false)
  const handleCallAdditionList = () => {
    setAdditionalItemOption(addCustomItem)
  }
  const handleBlurAmount = (e) => {
    let x = parseFloat(e.target.value).toFixed(2)
    return x
  }
  const { values, handleBlur, handleChange, errors, touched } = formikProps
  const { add_item } = values
  useEffect(() => {
    if (add_item?.length !== 0) {
      setAddItem(true)
    } else {
      setAddItem(false)
    }
  }, [add_item])
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="subtitle1">Additional credit</Typography>
      {addItem ? (
        <Box>
          <FieldArray name="add_item">
            {({ push, remove, form }) => {
              const { values } = form
              const { add_item } = values
              return (
                <Box
                  sx={{
                    border: 2,
                    borderColor: 'gray-line.main',
                    borderRadius: '10px',
                  }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, gap: 2 }}>
                    {add_item?.map((_, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          gap: 2,
                        }}
                      >
                        <Box sx={{ width: 1 }}>
                          <Field
                            name={`add_item.${index}.category_items`}
                            as={AdxDropdown}
                            onFocus={handleCallAdditionList}
                            onChange={(val) => {
                              handleChange(val)
                              setStateChanges(true)
                            }}
                            value={values?.add_item[index].category_items}
                            onBlur={handleBlur}
                            options={additionalItemOption}
                            errorMessage={
                              <ErrorMessage
                                name={`add_item.${index}.category_items`}
                                component={AdxErrorMessage}
                              />
                            }
                            isErrorShown={
                              touched.add_item &&
                              errors.add_item &&
                              errors.add_item[index]?.category_items &&
                              touched.add_item[index]?.category_items
                            }
                            renderValue={(val) => {
                              if (val.title) {
                                return <Typography>{val.title}</Typography>
                              } else {
                                return <Typography>{val.item}</Typography>
                              }
                            }}
                          >
                            <ListSubheader sx={{ lineHeight: '0', py: 1, position: 'static' }}>
                              <Typography variant="caption" color="light-gray-text.main">
                                NORMAL REMUNERATION
                              </Typography>
                            </ListSubheader>
                            {additionalItemOption
                              .filter((item) => {
                                if (item.custom_status === 0) {
                                  return item
                                } else {
                                  return null
                                }
                              })
                              .map((list, id) => {
                                return (
                                  <AdxMenuItem
                                    selectedvalue={values?.add_item[index].category_items}
                                    key={id}
                                    value={list}
                                    sx={{ px: 3.5 }}
                                    disabled={
                                      values?.add_item[index].category_items.id !== list.id &&
                                      values?.add_item?.find(
                                        (el) => el.category_items.id === list.id
                                      )
                                    }
                                  >
                                    {list.title}
                                  </AdxMenuItem>
                                )
                              })}
                            <ListSubheader sx={{ lineHeight: '0', py: 1, position: 'static' }}>
                              <Typography variant="caption" color="light-gray-text.main">
                                ADDITIONAL REMUNERATION
                              </Typography>
                            </ListSubheader>
                            {additionalItemOption
                              .filter((item) => {
                                if (item.custom_status === 1) {
                                  return item
                                } else {
                                  return null
                                }
                              })
                              .map((list, id) => {
                                return (
                                  <AdxMenuItem
                                    selectedvalue={values?.add_item[index].category_items}
                                    key={id}
                                    value={list}
                                    sx={{ px: 3.5 }}
                                    disabled={
                                      values?.add_item[index].category_items.id !== list.id &&
                                      values?.add_item?.find(
                                        (el) => el.category_items.id === list.id
                                      )
                                    }
                                  >
                                    {list.title}
                                  </AdxMenuItem>
                                )
                              })}
                            <ListSubheader sx={{ lineHeight: '0', py: 1, position: 'static' }}>
                              <Typography variant="caption" color="light-gray-text.main">
                                BENEFIT IN KIND
                              </Typography>
                            </ListSubheader>
                            {additionalItemOption
                              .filter((item) => {
                                if (item.custom_status === 3) {
                                  return item
                                } else {
                                  return null
                                }
                              })
                              .map((list, id) => {
                                return (
                                  <AdxMenuItem
                                    selectedvalue={values?.add_item[index].category_items}
                                    key={id}
                                    value={list}
                                    sx={{ px: 3.5 }}
                                    disabled={
                                      values?.add_item[index].category_items.id !== list.id &&
                                      values?.add_item?.find(
                                        (el) => el.category_items.id === list.id
                                      )
                                    }
                                  >
                                    {list.title}
                                  </AdxMenuItem>
                                )
                              })}
                            <ListSubheader sx={{ lineHeight: '0', py: 1, position: 'static' }}>
                              <Typography variant="caption" color="light-gray-text.main">
                                VALUE OF LIVING ACCOMODATION
                              </Typography>
                            </ListSubheader>
                            {additionalItemOption
                              .filter((item) => {
                                if (item.custom_status === 2) {
                                  return item
                                } else {
                                  return null
                                }
                              })
                              .map((list, id) => {
                                return (
                                  <AdxMenuItem
                                    selectedvalue={values?.add_item[index].category_items}
                                    key={id}
                                    value={list}
                                    sx={{ px: 3.5 }}
                                    disabled={
                                      values?.add_item[index].category_items.id !== list.id &&
                                      values?.add_item?.find(
                                        (el) => el.category_items.id === list.id
                                      )
                                    }
                                  >
                                    {list.title}
                                  </AdxMenuItem>
                                )
                              })}
                          </Field>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', columnGap: 1 }}>
                          <Box sx={{ width: 1 }}>
                            <Field
                              name={`add_item.${index}.value`}
                              as={AdxInput}
                              startAdornment={<InputAdornment position="start">RM</InputAdornment>}
                              inputProps={{ min: 0 }}
                              onChange={(e) => {
                                handleChange(e)
                                setStateChanges(true)
                              }}
                              onBlur={(e) => handleBlurAmount(e)}
                              errorMessage={
                                <ErrorMessage
                                  name={`add_item.${index}.value`}
                                  component={AdxErrorMessage}
                                />
                              }
                              isErrorShown={
                                touched.add_item &&
                                errors.add_item &&
                                errors.add_item[index]?.value &&
                                touched.add_item[index]?.value
                              }
                            />
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', height: '45px' }}>
                            <Icon
                              sx={{ color: 'error.main', cursor: 'pointer' }}
                              onClick={() => {
                                remove(index)
                                setStateChanges(true)
                              }}
                            >
                              remove_circle
                            </Icon>
                          </Box>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  <Box
                    sx={{
                      borderTop: 1,
                      borderColor: 'gray-line.main',
                      p: 0.5,
                    }}
                  >
                    <AdxButton
                      variant={'ghost'}
                      onClick={() => {
                        push({ category_items: '', repeat: 0, value: '' })
                        setStateChanges(true)
                      }}
                      startIcon={<Add />}
                      sx={{
                        width: '100%',
                        pl: 2,
                        display: 'flex',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <Typography sx={{ textDecoration: 'underline' }}>Add credit</Typography>
                    </AdxButton>
                  </Box>
                </Box>
              )
            }}
          </FieldArray>
        </Box>
      ) : (
        <FieldArray name="add_item">
          {({ push }) => {
            const handleAddItem = () => {
              push({ category_items: '', repeat: 0, value: '' })
              setStateChanges(true)
            }
            return (
              <Box
                sx={{
                  px: 12,
                  py: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: 'dashed',
                  borderColor: 'gray-line.main',
                  borderRadius: '10px',
                  my: 2,
                }}
              >
                <Typography color="light-gray-text.main" textAlign="center" sx={{ mb: 2 }}>
                  You have not added any additional credit yet
                </Typography>
                <AdxButton variant={'outlined'} onClick={handleAddItem} startIcon={<Add />}>
                  Add
                </AdxButton>
              </Box>
            )
          }}
        </FieldArray>
      )}
    </Box>
  )
}

export default CustomAdditional
